export const EntityTypes = {
    DRIVER:'DRIVER',
    VAT_INVOICE: 'VAT_INVOICE',
    VEHICLE: 'VEHICLE'
};
